package com.exura.components.icons

import androidx.compose.runtime.Composable
import com.exura.ui.Dimens
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.silk.components.text.SpanText

@Composable
fun Icon(
    iconSrc: String,
    modifier: Modifier = Modifier,
) {
    SpanText(
        text = iconSrc,
        modifier = Modifier
            .fontSize(Dimens.iconRelSizeDefault)
            .then(modifier)
    )
}
